import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import AppShell from '../layouts/AppShell.vue'
import PublicLayout from '../layouts/public.vue'
import { useAuthStore } from '../stores/auth'

const publicRoutes: RouteRecordRaw[] = [
  { path: '/auth/login', component: () => import('../legacy-app/pages/auth/login.vue'), meta: { public: true } },
  { path: '/auth/callback', component: () => import('../legacy-app/pages/auth/callback.vue'), meta: { public: true } },
  { path: '/auth/pay-callback', component: () => import('../legacy-app/pages/auth/pay-callback.vue'), meta: { public: true } },
  {
    path: '/public/cases',
    component: PublicLayout,
    meta: { public: true },
    children: [
      { path: '', component: () => import('../legacy-app/pages/public/cases/index.vue') },
      { path: ':id', component: () => import('../legacy-app/pages/public/cases/[id].vue') },
    ],
  },
  { path: '/org-auth/:token', component: () => import('../legacy-app/pages/org-auth/[token].vue'), meta: { public: true } },
  { path: '/org-impersonate/enter', component: () => import('../legacy-app/pages/org-impersonate/enter.vue'), meta: { public: true } },
]

const appRoutes: RouteRecordRaw[] = [
  { path: '', component: () => import('../legacy-app/pages/index.vue') },
  // 千川授权：需登录 + 默认壳（侧栏），勿放 publicRoutes
  { path: 'auth/qianchuan', component: () => import('../legacy-app/pages/auth/qianchuan.vue') },
  { path: 'account-email', component: () => import('../legacy-app/pages/account-email/index.vue') },
  { path: 'admin/burst-state-coef', component: () => import('../legacy-app/pages/admin/burst-state-coef.vue') },
  { path: 'admin/data-cleanup', component: () => import('../legacy-app/pages/admin/data-cleanup.vue') },
  { path: 'admin/historical-to-repair', component: () => import('../legacy-app/pages/admin/historical-to-repair.vue') },
  { path: 'admin/ops-f', component: () => import('../legacy-app/pages/admin/ops-f.vue') },
  { path: 'admin/ops-adjustment-amplitude', component: () => import('../legacy-app/pages/admin/ops-adjustment-amplitude.vue') },
  { path: 'admin/ops-rp-rankings', component: () => import('../legacy-app/pages/admin/ops-rp-rankings.vue') },
  { path: 'admin/roi-rule-restore', component: () => import('../legacy-app/pages/admin/roi-rule-restore.vue') },
  { path: 'admin/shop-diagnosis', component: () => import('../legacy-app/pages/admin/shop-diagnosis.vue') },
  { path: 'admin/sync-periodic-runs', component: () => import('../legacy-app/pages/admin/sync-periodic-runs.vue') },
  { path: 'admin/system-configs', component: () => import('../legacy-app/pages/admin/system-configs.vue') },
  { path: 'admin/users', component: () => import('../legacy-app/pages/admin/users.vue') },
  { path: 'admin/orgs', component: () => import('../legacy-app/pages/admin/orgs.vue') },
  { path: 'advertisers', component: () => import('../legacy-app/pages/advertisers/index.vue') },
  { path: 'advertisers/:id/campaigns', component: () => import('../legacy-app/pages/advertisers/[id]/campaigns.vue') },
  { path: 'ai-paid-video', component: () => import('../legacy-app/pages/ai-paid-video/index.vue') },
  { path: 'ai-video-prompts', component: () => import('../legacy-app/pages/ai-video-prompts/index.vue') },
  { path: 'algorithm-tasks', component: () => import('../legacy-app/pages/algorithm-tasks/index.vue') },
  { path: 'analytics', component: () => import('../legacy-app/pages/analytics/index.vue') },
  { path: 'audiences', component: () => import('../legacy-app/pages/audiences/index.vue') },
  { path: 'auto-material', component: () => import('../legacy-app/pages/auto-material/index.vue') },
  { path: 'material-inspect', component: () => import('../legacy-app/pages/material-inspect/index.vue') },
  { path: 'auto-placement', component: () => import('../legacy-app/pages/auto-placement/index.vue') },
  { path: 'budget-settings', component: () => import('../legacy-app/pages/budget-settings/index.vue') },
  { path: 'campaigns', component: () => import('../legacy-app/pages/campaigns/index.vue') },
  { path: 'class-u', component: () => import('../legacy-app/pages/class-u/index.vue') },
  { path: 'invalid-campaign-management', component: () => import('../legacy-app/pages/invalid-campaign-management/index.vue') },
  { path: 'materials', component: () => import('../legacy-app/pages/materials/index.vue') },
  { path: 'messages', component: () => import('../legacy-app/pages/messages/index.vue') },
  { path: 'modeling', component: () => import('../legacy-app/pages/modeling/index.vue') },
  { path: 'org-grants', component: () => import('../legacy-app/pages/org-grants/index.vue') },
  { path: 'org-operation-logs', component: () => import('../legacy-app/pages/org-operation-logs/index.vue') },
  { path: 'package-center', component: () => import('../legacy-app/pages/package-center/index.vue') },
  { path: 'products', component: () => import('../legacy-app/pages/products/index.vue') },
  { path: 'prompt-factory', component: () => import('../legacy-app/pages/prompt-factory.vue') },
  { path: 'report-data', component: () => import('../legacy-app/pages/report-data/index.vue') },
  { path: 'roi-adjustments', component: () => import('../legacy-app/pages/roi-adjustments/index.vue') },
  { path: 'rpa/tokens', component: () => import('../legacy-app/pages/rpa/tokens/index.vue') },
  { path: 'seedling', component: () => import('../legacy-app/pages/seedling/index.vue') },
  { path: 'transfer-shop', component: () => import('../legacy-app/pages/transfer-shop/index.vue') },
]

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...publicRoutes,
    {
      path: '/',
      component: AppShell,
      children: appRoutes,
    },
  ],
})

/** 无需登录的页面（不含 /auth/qianchuan，该页在壳内且需登录） */
const PUBLIC_AUTH_PATHS = new Set(['/auth/login', '/auth/callback', '/auth/pay-callback'])

router.beforeEach(async (to, _from, next) => {
  if (to.meta.public || to.path.startsWith('/public') || PUBLIC_AUTH_PATHS.has(to.path)) {
    return next()
  }

  const loginRedirect = { path: '/auth/login', query: { redirect: to.fullPath } }
  const authStore = useAuthStore()

  try {
    // 已有缓存则不再打 user-me（对齐 Nuxt middleware）
    if (!(authStore.isAuthenticated && authStore.user)) {
      const res = await fetch('/api/auth/user-me', { credentials: 'include' })
      if (!res.ok) return next(loginRedirect)
      // user-me 未登录仍返回 200 + { authenticated: false }，不能只看 res.ok
      const data = (await res.json()) as {
        authenticated?: boolean
        user?: any
        impersonating?: boolean
        adminUser?: any
        orgImpersonating?: boolean
        orgImpersonation?: any
      }
      if (!data?.authenticated || !data?.user) {
        authStore.clearUser()
        return next(loginRedirect)
      }
      authStore.setUser(data.user)
      authStore.impersonating = !!data.impersonating
      authStore.adminUser = data.adminUser || null
      authStore.orgImpersonating = !!data.orgImpersonating
      authStore.orgImpersonation = data.orgImpersonation || null
    }

    // AI 视频相关页：仅超管/代登可进（对齐 Nuxt middleware）
    if (
      (to.path.startsWith('/ai-paid-video') || to.path.startsWith('/ai-video-prompts')) &&
      !authStore.hasAdminAccess
    ) {
      return next({ path: '/' })
    }

    return next()
  } catch {
    if (authStore.isAuthenticated && authStore.user) return next()
    return next(loginRedirect)
  }
})
